// Common
export const selectItems = state => (state && state.items) || [];
export const selectFetching = state => state && state.fetching;
export const selectFetched = state => state && state.fetched;
export const selectError = state => state && state.error;

// Auth
export const selectUserCommunities = state => {
  return (state.auth && state.auth.user && state.auth.user.communities) || [];
};

export const selectNavCommunity = state => {
  return state.auth && state.auth.navCommunity;
};

export const selectLoggedAs = state => state.auth && state.auth.loggedAs;
export const selectUser = state => state.auth && state.auth.user;
export const selectRouting = state => state.routing;

export const selectLanguage = state => state.params.lng;

// Media
export const selectMediasByType = (state, type) => {
  let reducerType = type.toLowerCase();
  reducerType += reducerType !== "all" ? "s" : "";

  return reducerType === "albums" ? state.albums : state.medias[reducerType];
};

export const selectMediasItemsByType = (state, type) => {
  return selectItems(selectMediasByType(state, type));
};

export const selectMediasFetchingByType = (state, type) => {
  return selectFetching(selectMediasByType(state, type));
};

export const selectMediasFetchedByType = (state, type) => {
  return selectFetched(selectMediasByType(state, type));
};

export const selectMediasErrorByType = (state, type) => {
  return selectError(selectMediasByType(state, type));
};



// WEBPACK FOOTER //
// ./src/selectors/index.js